import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import forEach from "lodash/forEach";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import values from "lodash/values";
import { Rect } from "yfiles";
import { NODE_GROUP_MIN_SIZE } from "../../constants";
import getEdgesForNodes from "../getEdgesForNodes";
import highlightNodes from "../highlightNodes";
import morphLayout from "../morphLayout";
import findGroupNode from "../nodeOrEdgeSourceDataHandling/findGroupNode";
import getGraphNodeSources from "../nodeOrEdgeSourceDataHandling/getGraphNodeSources";
import nodeSourceFactory from "../nodeOrEdgeSourceDataHandling/nodeSourceFactory";
import addOrUpdateEdges from "./addOrUpdateEdges";
import addOrUpdateNode from "./addOrUpdateNode";
import createGroup from "./createGroup";
import updateGroup from "./updateGroup";
export default (graphComponentRef, documentObjects, updates, layoutAlgorithmRef, nodesLayoutsRef, setInProgress, completed, rejected, animateViewport = true) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) ||
        !documentObjects ||
        (isEmpty(updates.NodesSource) && isEmpty(updates.EdgesSource)))
        return false;
    setInProgress === null || setInProgress === void 0 ? void 0 : setInProgress(true);
    const updatesGroupMap = keyBy(updates.Groups, "Id");
    const prevNodeIds = map(flatMap(graphComponentRef.current.graph.nodes.toArray(), getGraphNodeSources), "NodeId");
    const processedNodeIds = new Set();
    const affectedNodes = new Set();
    const affectedNodesForMorphLayout = new Set();
    forEach(updates.NodesSource, n => {
        if (!graphComponentRef.current || processedNodeIds.has(n.NodeId)) {
            return;
        }
        processedNodeIds.add(n.NodeId);
        const nodeSource = nodeSourceFactory(n, documentObjects);
        const itemsWithSameGroupId = nodeSource.GroupId && nodeSource.PinnedToGroup
            ? map(filter(updates.NodesSource, e => Boolean(e.GroupId === nodeSource.GroupId && e.PinnedToGroup)), e => nodeSourceFactory(e, documentObjects))
            : [];
        if (nodeSource.GroupId &&
            nodeSource.PinnedToGroup &&
            !includes(prevNodeIds, nodeSource.NodeId)) {
            forEach(map(itemsWithSameGroupId, "NodeId"), nodeId => {
                processedNodeIds.add(nodeId);
            });
            const groupMeta = updatesGroupMap[nodeSource.GroupId];
            if (groupMeta) {
                const layout = nodesLayoutsRef === null || nodesLayoutsRef === void 0 ? void 0 : nodesLayoutsRef.current[nodeSource.NodeId];
                const groupLayout = new Rect((layout === null || layout === void 0 ? void 0 : layout.x) || 0, (layout === null || layout === void 0 ? void 0 : layout.y) || 0, Math.max((layout === null || layout === void 0 ? void 0 : layout.width) || 0, NODE_GROUP_MIN_SIZE.width), Math.max((layout === null || layout === void 0 ? void 0 : layout.height) || 0, NODE_GROUP_MIN_SIZE.height));
                const group = createGroup(graphComponentRef, documentObjects, itemsWithSameGroupId, groupMeta.Id, groupMeta.Name, groupMeta.ObjectCount, groupLayout);
                if (group) {
                    affectedNodes.add(group);
                    !layout && affectedNodesForMorphLayout.add(group);
                }
            }
        }
        else {
            const group = nodeSource.GroupId && nodeSource.PinnedToGroup
                ? findGroupNode(graphComponentRef, nodeSource.GroupId)
                : undefined;
            if (nodeSource.GroupId && group) {
                forEach(map(itemsWithSameGroupId, "NodeId"), nodeId => {
                    processedNodeIds.add(nodeId);
                });
                updateGroup(graphComponentRef, nodeSource.GroupId, itemsWithSameGroupId);
                affectedNodes.add(group);
            }
            else {
                const layout = nodesLayoutsRef === null || nodesLayoutsRef === void 0 ? void 0 : nodesLayoutsRef.current[nodeSource.NodeId];
                const { node } = addOrUpdateNode(graphComponentRef, documentObjects, nodeSource, layout);
                if (node) {
                    affectedNodes.add(node);
                    !layout && affectedNodesForMorphLayout.add(node);
                }
            }
        }
    });
    addOrUpdateEdges(graphComponentRef, values(updates.EdgesSource));
    highlightNodes(graphComponentRef, Array.from(affectedNodes));
    const affectedEdges = getEdgesForNodes(graphComponentRef, affectedNodes, true);
    if (affectedNodesForMorphLayout.size || affectedEdges.size) {
        morphLayout(graphComponentRef, layoutAlgorithmRef, affectedNodesForMorphLayout, affectedEdges, setInProgress, () => {
            completed === null || completed === void 0 ? void 0 : completed();
        }, () => {
            rejected === null || rejected === void 0 ? void 0 : rejected();
        }, animateViewport);
    }
    else {
        setInProgress === null || setInProgress === void 0 ? void 0 : setInProgress(false);
        completed === null || completed === void 0 ? void 0 : completed();
    }
    return true;
};
